export default __webpack_public_path__ + "static/media/bra-site.49b7f2e7.webp";